const getters = {
    getMenus(state) {
        return state.menus;
    },
}

export default getters